import { render, staticRenderFns } from "./vMultiplataforma.vue?vue&type=template&id=f8783442&scoped=true&"
import script from "./vMultiplataforma.vue?vue&type=script&lang=js&"
export * from "./vMultiplataforma.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f8783442",
  null
  
)

export default component.exports